var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    x: 0.5,
    y: 0.5,
    fill: "#FFF1E0",
    rx: 7.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DF7E0C",
    fillRule: "evenodd",
    d: "M13 7a6 6 0 1 0 0 12 6 6 0 0 0 0-12m-7.5 6a7.5 7.5 0 1 1 15 0 7.5 7.5 0 0 1-15 0m7.5-1.5a.75.75 0 0 1 .75.75V16a.75.75 0 0 1-1.5 0v-3.75a.75.75 0 0 1 .75-.75m0-.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5",
    clipRule: "evenodd"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    x: 0.5,
    y: 0.5,
    stroke: "#DF7E0C",
    rx: 7.5
  })));
};
export default SvgWarning;